import { STATUTS } from '@carte/domaine/statut';
import { z } from 'zod';

export const ROLES = ['admin', 'backoffice', 'mentor', 'terrain'] as const;
export const roleSchema = z.enum(ROLES);
export type RoleApp = z.infer<typeof roleSchema>;

export const statutSchema = z.enum(STATUTS);

export const PRECISIONS = ['adresse', 'commune', 'departement', 'pays', 'aucune'] as const;
export const precisionSchema = z.enum(PRECISIONS);
export type PrecisionLoc = z.infer<typeof precisionSchema>;

export const SOURCES = ['entreprise', 'adresse', 'commune', 'nominatim', 'manuel', 'terrain'] as const;
export const sourceSchema = z.enum(SOURCES);
export type SourceLoc = z.infer<typeof sourceSchema>;

export const CONFIANCES = ['elevee', 'moyenne', 'a_controler', 'non_trouve'] as const;
export const confianceSchema = z.enum(CONFIANCES);
export type ConfianceLoc = z.infer<typeof confianceSchema>;

export const ETATS_REVUE = ['aucune', 'a_revoir', 'validee', 'non_localisable'] as const;
export const etatRevueSchema = z.enum(ETATS_REVUE);
export type EtatRevue = z.infer<typeof etatRevueSchema>;

export const lonSchema = z.coerce.number().min(-180).max(180);
export const latSchema = z.coerce.number().min(-90).max(90);

export const pointSchema = z.object({ lon: lonSchema, lat: latSchema });
export type PointDto = z.infer<typeof pointSchema>;

/** Forme commune des erreurs de l'API. */
export const erreurSchema = z.object({
  erreur: z.string(),
  details: z.unknown().optional(),
});
export type ErreurDto = z.infer<typeof erreurSchema>;

/** Réponse des routes pas encore construites. */
export const nonImplementeSchema = z.object({ erreur: z.literal('non_implemente'), module: z.string() });

/** Identifiant entier lu dans un chemin d'URL. */
export const idEntierSchema = z.coerce.number().int().positive();

/** FeatureCollection de points (GeoJSON) avec propriétés typées. */
export function collectionPointsSchema<P extends z.ZodType>(proprietes: P) {
  return z.object({
    type: z.literal('FeatureCollection'),
    features: z.array(
      z.object({
        type: z.literal('Feature'),
        id: z.number().int().optional(),
        geometry: z.object({
          type: z.literal('Point'),
          coordinates: z.tuple([z.number(), z.number()]),
        }),
        properties: proprietes,
      }),
    ),
  });
}
